<script>
import ModalsTemplate from "../ModalsTemplate.vue";

import {mapActions} from "vuex";

//import toDate from "../../service/to-date.js";

import DatePicker from "@/components/fields/date-picker.vue";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    contractId: {
      type: String,
      required: true,
    },
  },

  components: {
    ModalsTemplate,
    DatePicker,
  },

  data: () => ({
    formData: {
      id: null,
      paymentDate: null,
      paid: null,
      comment: "",
    },

    model: true,
  }),

  watch: {
    model() {
      setTimeout(() => {
        this.$emit("close");
      }, 100);
    },
  },

  created() {
    if (this.data.id) {
      this.formData = JSON.parse(JSON.stringify(this.data));
      this.formData.paymentDate = this.formData.datePayment || this.formData.paymentDate;
      if (this.formData.comment == null) this.formData.comment = "";
    }
  },

  methods: {
    ...mapActions("admin-contract2026", ["ADD_PAYMENT"]),

    onSend() {
      if (this.$refs.form.validate()) {
        const params = { ...this.formData, contractId: this.contractId };

        this.ADD_PAYMENT(params).then((status) => {
          if (status != null) {
            this.$emit("refresh");
            this.model = false;
          }
        });
      }
    },
  },
};
</script>

<template>
  <modals-template :title="$t('Payment edit')" :width="650" v-model="model">
    <v-form @submit.prevent="() => false" ref="form" lazy-validation>
      <v-row>
        <v-col cols="12">
          <date-picker
              v-model="formData.paymentDate"
              :label="$t('Paid Date')"
              clearable
              autofocus
              required
              :minValue="'01-01-2000'"
              :maxValue="'01-01-2100'"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
              autocomplete="off"
              v-model="formData.paid"
              :label="$t('Summa')"
              outlined
              hide-details
              v-inputmask="$masks.number2"
              required
              :rules="[$rules.required]"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
              autocomplete="off"
              v-model="formData.comment"
              :label="$t('Kommentariya')"
              outlined
              hide-details
          />
        </v-col>
      </v-row>
    </v-form>

    <template slot="actions">
      <div class="d-flex w-100">
        <v-spacer/>
        <v-btn color="primary" class="btn-accent" @click="onSend">
          {{ $t("Save") }}
        </v-btn>
      </div>
    </template>
  </modals-template>
</template>